import { render, staticRenderFns } from "./HighEndCheck.vue?vue&type=template&id=07810a13&scoped=true&"
import script from "./HighEndCheck.vue?vue&type=script&lang=js&"
export * from "./HighEndCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07810a13",
  null
  
)

export default component.exports